document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.variant-link').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
  
        // No need for event.preventDefault() since buttons don't navigate
  
        var modalId = this.getAttribute('data-modal');
        var variantId = this.getAttribute('data-variant-id');
        var modal = document.querySelector(modalId);
  
        if (modal) {
          // Attach the variant ID to the modal
          modal.setAttribute('data-variant-id', variantId);
  
          // Open the modal by adding the 'is-active' class
          modal.classList.add('is-active');
  
          // Wait for the modal to be fully rendered
          setTimeout(function () {
            // Find the variant select box inside the modal
            var selectBox = modal.querySelector('.product-variant-select');
            if (selectBox) {
              // Set the select box to the correct variant
              selectBox.value = variantId;
  
              // Trigger the change event if necessary
              var changeEvent = new Event('change');
              selectBox.dispatchEvent(changeEvent);
            }
          }, 100); // Adjust the timeout as needed
        }
      });
    });
  
    // Handle closing the modal
    document.querySelectorAll('.quick-add-modal__toggle').forEach(function (closeButton) {
      closeButton.addEventListener('click', function () {
        var modal = this.closest('.quick-add-modal');
        modal.classList.remove('is-active');
      });
    });
  });